export default __webpack_public_path__ + "static/media/use_action_back_cz.962a52aa.png";